import React, { useEffect, useState } from 'react';
import './inaugration.css'; // Import the CSS styles

const InaugurationPage = () => {
  const [animateTitle, setAnimateTitle] = useState(false);
  const [animateText, setAnimateText] = useState(false);
  
  useEffect(() => {
    const outerSection = document.querySelector('.rnOuter');
    let hasRedirected = false;

    const handleClick = () => {
      if (!hasRedirected) {
        hasRedirected = true;
        outerSection.classList.add('curtains-move'); // Add class to trigger animation
        setAnimateTitle(true); // Trigger title animation

        setTimeout(() => {
          setAnimateText(true); // Trigger text animation after title animation
        }, 2000); // Adjust timing based on title animation duration

        setTimeout(() => {
          window.location.href = '/'; // Change to your desired route
        }, 8000); // Wait for 5 seconds before redirecting
      }
    };

    outerSection.addEventListener("click", handleClick);

    return () => {
      outerSection.removeEventListener("click", handleClick);
    };
  }, []);

  return (
    <div className="rxWorld">
      <section className="rnOuter">
        <section className="aoTable">
          <div className="aoTableCell">
            <div className="launching-message">
              <h1 className={`animated-title ${animateTitle ? 'trigger-animation-title' : ''}`}>
                Welcome to UDYAMA 1.0!
              </h1>
              <p className={`animated-text ${animateText ? 'trigger-animation' : ''}`}>
                Please Hold On...
              </p>
              <div className="loading-spinner"></div>
              <p className={`website-text ${animateText ? 'trigger-animation' : ''}`}>
                udyamadtekerala.in
              </p>
            </div>
          </div>
        </section>
        <div className="rnInner">
          {[...Array(10)].map((_, index) => (
            <div key={index} className="rnUnit"></div>
          ))}
        </div>
      </section>
    </div>
  );
};

export default InaugurationPage;
